import { render, staticRenderFns } from "./CardHistory.vue?vue&type=template&id=6ce81b76"
import script from "./CardHistory.vue?vue&type=script&lang=js"
export * from "./CardHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports